import _ from 'lodash'
import { z } from 'zod'

// updating this model?  don't break current data!
// see _UpdatingSchemas.md
export const RComment = z.object({
	message: z.string(),
	authorName: z.string(),
	authorUpn: z.union([z.string(), z.undefined()]),
	timestamp: z.number(),
	encounterAppLastStatusDT: z.string(),
})

export const RComments = z.array(RComment)

export type Comment = z.infer<typeof RComment>

export const commentIsEditable = (comment: Comment, encounterAppLastStatusDT: string) => {
	return comment.encounterAppLastStatusDT === encounterAppLastStatusDT
}
